import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { Dialog, Typography, DialogActions, DialogContent } from '@mui/material';

import Iconify from 'src/components/iconify';

// ----------------------------------------------------------------------

export const PREMIUM_SUPPORT_WHATSAPP_URL =
  'https://api.whatsapp.com/send/?phone=5511971048980&text=Ol%20gostaria%20de%20adquirir%20funcionalidade%20premium';

export type PremiumFeatureDialogProps = {
  open: boolean;
  onClose: () => void;
};

export function PremiumFeatureDialog({ open, onClose }: PremiumFeatureDialogProps) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogContent sx={{ textAlign: 'center', pt: 3, pb: 1.5 }}>
        <Box
          component="img"
          alt=""
          src="/assets/icons/premium/crown-simple-fill.svg"
          sx={{ width: 44, height: 44, mx: 'auto', mb: 2 }}
        />
        <Typography variant="h6" gutterBottom>
          Funcionalidade Premium
        </Typography>
        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          Entre em contato com o Suporte.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ flexDirection: 'column', gap: 1, pt: 1.5 }}>
        <Button
          variant="contained"
          color="success"
          startIcon={<Iconify icon="mdi:whatsapp" />}
          href={PREMIUM_SUPPORT_WHATSAPP_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          Falar com Suporte
        </Button>
        <Button color="inherit" onClick={onClose}>
          Fechar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
